import { useState, useEffect } from 'react';
import { MotifTextLink, MotifIcon, MotifChip } from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Recoil_Selected_Account_State,
  Current_User,
  Recoil_All_Accounts_Quarter_State,
  System_Date_Time_State,
  Recoil_Quarter_State,
} from '../../../../recoil/recoil';
import { actionIcLaunch24px } from '@ey-xd/motif-react/assets/icons';

import {
  SubmitButtonContainer,
  Hyperlink,
  HyperlinkText,
  TitleContainer,
  TitleTextContainer,
  SubHeaderTopContainerGcsp,
  SubHeaderTopTitle,
  TitleAccount,
  TitleText,
  SubHeaderTopHyperlink,
} from '../../../atoms/subHeaderText/subHeader.styles';
import { getAlertBarDetails } from '../../../../util/commonFunctions';
import { PAGE } from '../../../../constants/commonConstants';

const SubHeaderTopGcsp = () => {
  const [selectedAccount, setSelectedAccount] = useRecoilState(Recoil_Selected_Account_State);
  const currentUser = useRecoilValue(Current_User);
  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);
  const [quarterChipInfo, setQuarterChipInfo] = useState(null);
  const [monthChipInfo, setMonthChipInfo] = useState({});
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  let alertStatusDetails;

  useEffect(() => {
    if (quarterData != null && currentUser != null && allAccountsQuarterData != null) {
      getMotifChip();
    }
  }, [quarterData, currentUser, allAccountsQuarterData]);

  const getMotifChip = async () => {
    let apiPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setQuarterChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setMonthChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }
  };

  const getUserForecastDueInfo = dueDetails => {
    const chipStyle = {
      color: '#ffffff',
    };
    const shouldApplyStyle =
      dueDetails.userDropdownChip === 'Submitted' || dueDetails.userDropdownChip === 'Missed';
    const chipType =
      dueDetails.userDropdownChip === 'Submitted' || dueDetails.userDropdownChip === 'Missed'
        ? 'outlined'
        : undefined;

    const isOpensOn =
      dueDetails.userDropdownChip.includes('Opens on') ||
      dueDetails.userDropdownChip.includes('Due on');
    const variant = isOpensOn ? 'monochrome-dark' : dueDetails.type;

    return (
      <MotifChip variant={variant} type={chipType} style={shouldApplyStyle ? chipStyle : undefined}>
        {dueDetails.userDropdownChip}
      </MotifChip>
    );
  };

  return (
    <>
      {quarterData != null && quarterChipInfo != null && (
        <SubHeaderTopContainerGcsp>
          <TitleContainer>
            <TitleTextContainer>
              <SubHeaderTopTitle>
                <TitleAccount>{selectedAccount?.accountName}:</TitleAccount>
                <TitleText>
                  3 Months{' '}
                  {quarterData?.quarter_start_date === quarterData?.current_month_start_date
                    ? `& ${quarterData?.quarter} Forecast`
                    : 'Forecast'}
                </TitleText>
              </SubHeaderTopTitle>
            </TitleTextContainer>
            {getUserForecastDueInfo(quarterChipInfo)}
          </TitleContainer>

          <SubmitButtonContainer>
            <Hyperlink>
              <MotifTextLink
                variant="alt"
                href={
                  selectedAccount &&
                  `${process.env.REACT_APP_ACCOUNT_LENS_URL}app/dashboard/pipeline/${selectedAccount.ey_dunsnumber}`
                }
                target="_blank"
              >
                <MotifIcon src={actionIcLaunch24px} style={{ color: '#FFE600' }} />
                <SubHeaderTopHyperlink>View Account in LENS</SubHeaderTopHyperlink>
              </MotifTextLink>
            </Hyperlink>
            <Hyperlink>
              <MotifTextLink
                variant="alt"
                href={
                  selectedAccount &&
                  `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&forceUCI=1&pagetype=entityrecord&etn=account&id=${selectedAccount.account_id}`
                }
                target="_blank"
              >
                <MotifIcon src={actionIcLaunch24px} style={{ color: '#FFE600' }} />
                <SubHeaderTopHyperlink>View Opportunites in EY CRM</SubHeaderTopHyperlink>
              </MotifTextLink>
            </Hyperlink>
          </SubmitButtonContainer>
        </SubHeaderTopContainerGcsp>
      )}
    </>
  );
};

export default SubHeaderTopGcsp;
